import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { useParams } from "react-router";
import { Alert, ErrorBoundary } from "@platform/design-system";
import { PPX_FINANCIALS_PREMIUM_OVERRIDES } from "@platform/feature-flags";
import { FinancialsTab } from "@platform/mpx-financials-tab";

import { CircularProgressCentered } from "../../../../../../components/CircularProgressCentered";
import { useRfpDetails } from "../../../../../../hooks/useRfpDetails";
import { useCarrierSequenceContext } from "../../CarrierSequenceContext";

const FinancialContent = (): React.JSX.Element => {
  const { id: rfpId } = useParams<{ id: string }>();
  const { appliedToAllCarrierOrder } = useCarrierSequenceContext();
  const premiumOverridesEnabled = useFeatureIsOn(
    PPX_FINANCIALS_PREMIUM_OVERRIDES,
  );

  if (!rfpId) {
    throw new Error("Financial route mounted without an :id param");
  }

  const {
    data: rfpDetails,
    isLoading,
    error,
  } = useRfpDetails({
    rfpId,
    enabled: true,
  });

  const ecoRfpId = rfpDetails?.ecoRfpId ?? "";

  if (error) {
    return <Alert severity="error">Failed to load RFP details.</Alert>;
  }

  if (isLoading || !ecoRfpId) {
    return <CircularProgressCentered />;
  }

  return (
    <FinancialsTab
      rfpId={ecoRfpId}
      carrierOrder={appliedToAllCarrierOrder}
      premiumOverridesEnabled={premiumOverridesEnabled}
    />
  );
};

const Financial = (): React.JSX.Element => (
  <ErrorBoundary>
    <FinancialContent />
  </ErrorBoundary>
);

export default Financial;
